var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14349 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14349 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7C0 5.14349 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14349 0 7 0ZM6.128 8.381L4.573 6.825C4.51725 6.76925 4.45107 6.72503 4.37824 6.69486C4.3054 6.66469 4.22734 6.64917 4.1485 6.64917C4.06966 6.64917 3.9916 6.66469 3.91876 6.69486C3.84593 6.72503 3.77975 6.76925 3.724 6.825C3.61142 6.93758 3.54817 7.09028 3.54817 7.2495C3.54817 7.40872 3.61142 7.56142 3.724 7.674L5.704 9.654C5.75959 9.71003 5.82572 9.75449 5.89858 9.78484C5.97143 9.81518 6.04958 9.83081 6.1285 9.83081C6.20742 9.83081 6.28557 9.81518 6.35842 9.78484C6.43128 9.75449 6.49741 9.71003 6.553 9.654L10.653 5.553C10.7095 5.49749 10.7544 5.43133 10.7852 5.35837C10.816 5.28539 10.8321 5.20705 10.8324 5.12785C10.8328 5.04864 10.8175 4.97015 10.7874 4.8969C10.7573 4.82365 10.7129 4.75708 10.657 4.70104C10.601 4.645 10.5345 4.6006 10.4613 4.5704C10.388 4.54019 10.3096 4.52479 10.2304 4.52506C10.1512 4.52533 10.0728 4.54129 9.99979 4.572C9.92678 4.60271 9.86058 4.64757 9.805 4.704L6.128 8.381Z",
    fill: "#00875A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d37eccd0aeb561cf0ebf9cbf82330025.svg";
export { ForwardRef as ReactComponent };